export default __webpack_public_path__ + "static/media/security-manager-right-with-ending.66d48bbc.png";